<template>
  <div>
    <!-- 商家管理 -->
    <el-row>
      <el-form
        :inline="true"
        :model="filters"
        @submit.native.prevent
        class="demo-form-inline toolbar"
        style="padding-bottom: 0px"
      >
        <el-form-item label="商家店名">
          <el-input
            v-model.trim="filters.merchantName"
            placeholder="请输入商家店名"
            @keyup.enter.native.prevent="enterSearchMember"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="商家类别">
          <el-select
            clearable
            v-model="filters.secondLevelId"
            placeholder="请选择商家类别"
            @clear="handleClearStr"
            filterable
          >
            <el-option
              v-for="item in serverList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            plain
            @click.native.prevent="handleFindPage"
            >查询</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button type="danger" icon="el-icon-plus" plain @click="handleAdd"
            >新增</el-button
          >
        </el-form-item>
      </el-form>
    </el-row>

    <!-- 表格内容栏 -->
    <el-table
      :data="tableData"
      style="width: 100%"
      :row-style="tableRowStyle"
      :cell-style="{ 'text-align': 'center', 'font-size': '16px' }"
      :header-cell-style="tableHeaderColor"
    >
      <el-table-column
        prop="merchantName"
        label="商家店名"
        :show-overflow-tooltip="true"
        min-width="120"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="principalName"
        label="商家姓名"
        :show-overflow-tooltip="true"
        min-width="100"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="principalPhone"
        label="商家电话"
        :show-overflow-tooltip="true"
        min-width="120"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="principalIDCard"
        label="商家身份证号"
        :show-overflow-tooltip="true"
        min-width="180"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="address"
        label="详细地址"
        :show-overflow-tooltip="true"
        min-width="200"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="secondLeves"
        label="服务类别"
        :show-overflow-tooltip="true"
        min-width="140"
        align="center"
        :formatter="firstLevelFormatter"
      ></el-table-column>
      <!-- <el-table-column
        prop="communityIds"
        label="服务范围"
        :show-overflow-tooltip="true"
        min-width="140"
        align="center"
        :formatter="communityFormatter"
      ></el-table-column> -->
      <el-table-column
        prop="remark"
        label="备注"
        :show-overflow-tooltip="true"
        min-width="140"
        align="center"
      ></el-table-column>
      <el-table-column label="操作" min-width="250" align="center">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="success"
            plain
            @click="look(scope.$index, scope.row)"
            >查看</el-button
          >
          <!--
            <el-button
              icon="el-icon-document"
              type="warning"
              size="mini"
              @click="fix(scope.$index, scope.row)"
            >修改</el-button>
          -->
          <el-button
            type="danger"
            size="mini"
            plain
            @click="handleDelete(scope.$index, scope.row)"
            >删除</el-button
          >
          <el-button
            type="success"
            size="mini"
            plain
            @click="passWord(scope.$index, scope.row)"
            >重置密码</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination
      background
      layout="total,prev, pager, next,jumper"
      :total="total"
      style="margin-top: 20px"
      align="center"
      class="fenye"
      @current-change="changePage"
      :current-page="currentPage"
    ></el-pagination>

    <!-- 商家新增 -->
    <el-dialog
      :title="
        status == 0
          ? '商家新增'
          : status == 1
          ? '商家查看'
          : status == 2
          ? '商家修改'
          : ''
      "
      width="50%"
      top="5vh"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      @close="closeDialogReset"
      center
    >
      <el-form
        :model="addForm"
        label-width="120px"
        :rules="dataFormRules"
        ref="dataForm"
        label-position="right"
      >
        <el-row type="flex" justify="center">
          <el-col :span="22">
            <el-row>
              <el-col :span="12">
                <el-form-item label="商家类别">
                  <el-select
                    v-model="addForm.principaType"
                    placeholder="请选择商家类别"
                    :disabled="disabled"
                    @change="principaTypeChange"
                  >
                    <el-option
                      v-for="item in principaTypeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="商家姓名:" prop="principalName">
                  <el-input
                    v-model.trim="addForm.principalName"
                    clearable
                    :disabled="disabled"
                    v-if="addForm.principaType == 1"
                  ></el-input>
                  <el-select
                    v-model="addForm.principalName"
                    placeholder="请选择商家"
                    :disabled="disabled"
                    @change="principalNameChange"
                    v-else
                  >
                    <el-option
                      v-for="item in principalNameList"
                      :key="item.id"
                      :label="item.principalName"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="商家电话:" prop="principalPhone">
                  <el-input
                    v-model.trim="addForm.principalPhone"
                    clearable
                    :disabled="disabled"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="商家身份证号:" prop="principalIDCard">
                  <el-input
                    v-model.trim="addForm.principalIDCard"
                    clearable
                    :disabled="disabled"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12" v-if="addForm.principaType == 1">
                <el-form-item label="商家店名:" prop="merchantName">
                  <el-input
                    v-model.trim="addForm.merchantName"
                    clearable
                    :disabled="disabled"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="商家地址:" prop="address">
                  <el-input
                    :disabled="disabled"
                    suffix-icon="el-icon-location-outline"
                    v-model.trim="addForm.address"
                    @focus="focusAdd"
                    id="address"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="营业执照:" prop="picture">
                  <el-upload
                    class="avatar-uploader"
                    action="string"
                    v-model="addForm.picture"
                    accept="image/png, image/jpeg"
                    list-type="picture-card"
                    :file-list="fileList"
                    :http-request="uploadSectionFile"
                    :before-upload="uploadSuccess"
                    :on-remove="handleRemove"
                    :limit="7"
                    ref="imagePic"
                    v-if="!disabled"
                  >
                    <i class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                  <div
                    v-for="item in fileList"
                    :key="item.id"
                    style="float: left; margin-right: 10px"
                  >
                    <el-image
                      style="width: 150px; height: 150px"
                      :src="item.url"
                      :preview-src-list="[item.url]"
                    ></el-image>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="服务类别:" prop="secondLevelIds">
                  <el-checkbox-group
                    v-model="addForm.secondLevelIds"
                    :disabled="disabled"
                  >
                    <el-checkbox
                      v-for="item in serverList"
                      :label="item.id"
                      :key="item.id"
                      >{{ item.name }}</el-checkbox
                    >
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- <el-row>
              <el-col :span="24">
                <el-form-item label="服务范围:" prop="communityIds">
                  <el-checkbox-group
                    v-model="addForm.communityIds"
                    :disabled="disabled"
                  >
                    <el-checkbox
                      v-for="item in communityList"
                      :label="item.id"
                      :key="item.id"
                      >{{ item.name }}</el-checkbox
                    >
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
            </el-row> -->
            <el-row>
              <el-col :span="24">
                <el-form-item label="备注:" prop="remark">
                  <el-input
                    :disabled="disabled"
                    type="textarea"
                    :rows="4"
                    v-model.trim="addForm.remark"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button v-if="!disabled" @click.native="dialogVisible = false"
          >取消</el-button
        >
        <el-button
          v-if="!disabled"
          type="primary"
          :loading="dialogloading"
          @click.native="submitForm"
          >确定</el-button
        >
        <el-button
          v-if="disabled"
          type="primary"
          @click.native="dialogVisible = false"
          >确认</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      class="el-dialog-map"
      width="60%"
      title="住址设置"
      :visible.sync="dialogFormVisibleSafe"
      @close="closeMap"
    >
      <el-input
        v-model="keyword"
        style="position: absolute; left: 108px; top: 108px; z-index: 999"
        class="fix-width"
      ></el-input>
      <div class="oldmanmap" style="position: relative">
        
      </div>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button type="primary" @click="sureMap">确定</el-button>
      </div>
    </el-dialog>

    <!-- 重置密码的dialog模态框 -->
    <el-dialog
      title="重置密码"
      width="30%"
      :visible.sync="passDialogFormVisible"
      :close-on-click-modal="false"
      @close="closeDialogResetCode"
    >
      <el-form
        :model="codeDataForm"
        label-width="100px"
        :rules="codeDataFormRules"
        ref="codeDataForm"
        :size="size"
        label-position="right"
      >
        <el-form-item label="密码:" prop="password">
          <el-input
            v-model="codeDataForm.password"
            auto-complete="off"
            placeholder="请输入密码"
            style="width: 80%"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码:" prop="confirmPwd">
          <el-input
            v-model="codeDataForm.confirmPwd"
            auto-complete="off"
            placeholder="请输入确认密码"
            style="width: 80%"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button :size="size" @click.native="passDialogFormVisible = false"
          >取消</el-button
        >
        <el-button :size="size" type="primary" @click.native="submitFormCode"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import KtButton from "@/components/KtButton";
export default {
  components: {
    KtButton,
  },
  data() {
    var validatePass2 = (rule, value, callback) => {
      if (value !== this.codeDataForm.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      pageNum: 1,
      pageSize: 10,
      currentPage: 1,
      total: 0,
      tableData: [],
      size: "medium",
      filters: {
        merchantName: "",
      },
      dialogloading: false,
      status: 0, //0--商家新增，1--商家查看，2--商家修改
      disabled: true,
      dialogVisible: false,
      addForm: {
        principaType: "1",
        address: "",
        secondLevelIds: [],
        communityIds: [],
        picture: [],
        merchantName: "",
        remark: "",
        principalName: "",
        principalPhone: "",
        principalIDCard: "",
      },
      principaTypeList: [
        {
          value: "1",
          label: "普通商家",
        },
        {
          value: "2",
          label: "统分平台商家",
        },
      ],
      // 统分平台商家选择数据源
      principalNameList: [],
      id: "",
      fileList: [],
      fileDataList: [],
      fileIndex: null,
      dataFormRules: {
        merchantName: [
          { required: true, message: "不能为空", trigger: "blur" },
          {
            min: 1,
            max: 30,
            message: "长度在 1 到 30 个字符",
            // trigger: 'blur',
          },
        ],
        principalName: [
          { required: true, message: "不能为空", trigger: "blur" },
          {
            min: 1,
            max: 10,
            message: "长度在 1 到 10 个字符",
            // trigger: 'blur',
          },
        ],
        principalPhone: [
          { required: true, message: "不能为空", trigger: "blur" },
          {
            pattern: /^((0\d{2,3}-\d{7,8})|(1[34578]\d{9}))$/,
            message: "请输入正确的手机号",
            // trigger: 'blur',
          },
        ],
        principalIDCard: [
          { required: false, message: "不能为空", trigger: "blur" },
          {
            pattern:
              /^[1-9][0-9]{5}([1][9][0-9]{2}|[2][0][0|1][0-9])([0][1-9]|[1][0|1|2])([0][1-9]|[1|2][0-9]|[3][0|1])[0-9]{3}([0-9]|[X])$/,
            message: "请输入正确的身份证号",
            // trigger: 'blur',
          },
        ],
        address: [{ required: true, message: "不能为空", trigger: "blur" }],
        remark: [
          {
            min: 0,
            max: 500,
            message: "长度在 0 到 500 个字符",
            // trigger: 'blur',
          },
        ],
        secondLevelIds: [
          { required: true, message: "不能为空", trigger: "change" },
        ],
        communityIds: [
          { required: true, message: "不能为空", trigger: "change" },
        ],
      },
      pageResult: {},
      keyword: "", //模糊搜索
      oldmanlng: "", //经度
      oldmanlat: "", //纬度
      postionMap: { lng: 0, lat: 0 }, //点击获取经纬度
      postionHuiXian: { lng: 0, lat: 0 }, //回显的经纬度坐标
      add: { jd: "", wd: "", siteName: "", site: "" }, //添加的mark
      showMark: false, //Mark点显示隐藏
      showMarkHuiXian: false, //修改回显mark点的提示
      dialogFormVisibleSafe: false,
      center: { lng: 0, lat: 0 }, //中心点
      zoom: 3, //缩放比例
      mapType: "", //地图类型，不填就是默认样式
      //设置自定义主题
      mapStyle: {
        styleJson: [
          {
            featureType: "all",
            elementType: "geometry",
            stylers: {
              hue: "#007fff",
              saturation: 89,
            },
          },
          {
            featureType: "water",
            elementType: "all",
            stylers: {
              color: "#ffffff",
            },
          },
        ],
      },
      serverList: [], //服务列表
      communityList: [], //服务范围列表
      passDialogFormVisible: false, //密码重置弹窗
      codeDataForm: {}, //重置密的form表单数据
      codeDataFormRules: {
        password: [
          { required: true, message: "不能为空", trigger: "blur" },
          {
            pattern: /^[A-Za-z0-9]+$/,
            message: "请输入由数字或者字母组成的字符",
          },
          { min: 6, max: 16, message: "长度在 6到 16 个字符" },
        ],
        confirmPwd: [
          { required: true, message: "不能为空", trigger: "blur" },
          {
            pattern: /^[A-Za-z0-9]+$/,
            message: "请输入由数字或者字母组成的字符",
          },
          { min: 6, max: 16, message: "长度在 6到 16 个字符" },
          { validator: validatePass2, trigger: "blur" },
        ],
      },
      id: "",
      userId: "",
    };
  },
  methods: {
    firstLevelFormatter(row) {
      if (row.secondLevelIds) {
        let firstLevelWord = [];
        let secondLevelList = row.secondLevelIds;
        this.serverList.forEach((item) => {
          secondLevelList.forEach((ele) => {
            if (ele == item.id) {
              firstLevelWord.push(item.name);
            }
          });
        });
        return firstLevelWord.join(",");
      }
    },
    communityFormatter(row) {
      if (row.communityIds) {
        let list = [];
        let communitList = row.communityIds;
        this.communityList.forEach((item) => {
          communitList.forEach((e) => {
            if (item.id == e) {
              list.push(item.name);
            }
          });
        });
        return list.join(",");
      }
    },
    /* 
      键盘事件 按下键盘回车 查询
    */
    enterSearchMember(e) {
      console.log("回车搜索", keyCode, e);
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.pageNum = 1;
        this.currentPage = 1;
        this.findPage();
      }
    },

    /* 
      点击查询按钮查询
    */
    handleFindPage() {
      this.findPage();
    },

    handleClearStr() {
      this.pageNum = 1;
    },

    //删除
    handleDelete(index, row) {
      this.$confirm("是否删除该数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      }).then(() => {
        this.$postForm("omc/merchandis/haveMerchant", { id: row.id }).then(
          (res) => {
            //判断该商家是否有商品
            if (res.result) {
              this.$message({
                message: "该商家还存在商品，不能删除",
                type: "error",
              });
            } else {
              this.$postForm("uac/merchant/delet", { id: row.id }).then(
                (res) => {
                  if (res.code == 200) {
                    this.$message({ type: "success", message: res.message });
                    this.findPage();
                  } else {
                    this.$message({ type: "error", message: res.message });
                  }
                }
              );
            }
          }
        );
      });
    },

    //重置密码
    passWord(index, row) {
      this.userId = row.userId;
      this.passDialogFormVisible = true;
    },

    //重置密码提交数据
    submitFormCode() {
      this.$refs.codeDataForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            let params = Object.assign({}, this.codeDataForm);
            params.userId = this.userId;
            this.dialogloading = true;
            console.log(params);
            this.$postJson("uac/user/resetPwd", params).then((res) => {
              console.log(res);
              this.dialogloading = false;
              if (res.code == 200) {
                this.$message({ message: "操作成功", type: "success" });
                this.passDialogFormVisible = false;
                this.$refs["codeDataForm"].resetFields();
              } else {
                this.$message({
                  message: "操作失败, " + res.message,
                  type: "error",
                });
              }
              this.findPage();
            });
          });
        }
      });
    },

    //关闭重置密码的dialog框
    closeDialogResetCode() {
      this.$refs.codeDataForm.resetFields(); //移除校验结果并重置字段值
    },

    /* 
      关闭新增和修改的dialog清除验证
    */
    closeDialogReset() {
      this.$refs.dataForm.resetFields(); //移除校验结果并重置字段值
      this.fileList = [];
      this.addForm = {
        address: "",
        secondLevelIds: [],
        communityIds: [],
        picture: [],
        merchantName: "",
        remark: "",
        principalName: "",
        principalPhone: "",
        principalIDCard: "",
      };
    },

    /* 
      新增
    */
    handleAdd() {
      this.disabled = false;
      this.status = 0;
      this.addForm = {
        principaType: "1",
        address: "",
        secondLevelIds: [],
        communityIds: [],
        picture: [],
        merchantName: "",
        remark: "",
        principalName: "",
        principalPhone: "",
        principalIDCard: "",
      };
      // 初始化服务项目和服务范围的数据源
      this.getServer();
      // this.getCommunityList();
      this.dialogVisible = true;
      this.$refs.dataForm.resetFields(); //移除校验结果并重置字段值
    },

    // 商家类型选择事件
    principaTypeChange(value) {
      console.log(value, "principaTypeChange");
      this.addForm = {
        principaType: value,
        address: "",
        secondLevelIds: [],
        communityIds: [],
        picture: [],
        merchantName: "",
        remark: "",
        principalName: "",
        principalPhone: "",
        principalIDCard: "",
      };
      this.principalNameList = [];
      this.$refs.dataForm.resetFields(); //移除校验结果并重置字段值
      this.$postJson("uac/merchant/tfptServiceInit").then((res) => {
        console.log(res, "?????");
        if (res.code == 200) {
          let dataArr = res.result;
          let arr = [];
          for (let key in dataArr) {
            console.log(key + "---" + dataArr[key]);
            let obj = {
              id: key,
              principalName: dataArr[key],
            };
            arr.push(obj);
          }
          this.principalNameList = arr;
        }
      });
    },
    // 统分平台商家选择事件
    principalNameChange(value) {
      this.addForm.serviceId = value;
      // 查询服务商详情
      this.$postJson("uac/merchant/tfptService", {
        serviceId: Number(value),
      }).then((res) => {
        if (res.code == 200) {
          console.log(res.result.adrr, "res.result.adrr");
          this.addForm.address = res.result.adrr;
          this.getServiceMap(res.result.adrr);
          // 查询服务商员工详情列表
          this.$postJson("uac/merchant/tfptServiceStaff", {
            serviceId: Number(value),
          }).then((res) => {
            if (res.code == 200 && res.result.length > 0) {
              console.log(res.result[0]);
              this.addForm.serviceStaffId = res.result[0].id;
              this.addForm.principalPhone = res.result[0].tel;
              this.addForm.principalIDCard = res.result[0].card;
            }
          });
        }
      });
    },
    // 获取商家地址经纬度
    getServiceMap(address) {
      console.log(address, "address");
      
    },
    //修改
    fix(index, row) {
      this.id = row.id;
      this.status = 2;
      this.dialogVisible = true;
      this.back(row);
    },

    back(row) {
      console.log(row.serviceType);
      this.addForm = Object.assign({}, this.addForm, row);
      this.addForm.secondLevelIds = row.secondLevelIds
      if (row.serviceType == 1) {
        this.addForm.principaType = "2";
      } else {
        this.addForm.principaType = "1";
      }
      this.$set(this.addForm, "picture", this.addForm.imgsCode.split(";"));
      for (var i = 0; i < this.addForm.picture.length; i++) {
        if (
          this.addForm.picture[i] != "" &&
          this.addForm.picture[i] != undefined &&
          this.addForm.picture[i] != null
        ) {
          this.$postForm(
            "opc/file/queryAttachmentById/" + this.addForm.picture[i]
          ).then((res) => {
            this.fileList.push({
              name: res.result.name,
              url: "http://51cs8.com/" + res.result.path + res.result.name,
            });
          });
        }
      }
    },

    //查看
    look(index, row) {
      console.log(row, "row");
      this.disabled = true;
      this.status = 1;
      this.dialogVisible = true;
      this.back(row);
    },

    //上传图片
    uploadSectionFile(param) {
      var fileObj = param.file;
      console.log(param.file);
      if (fileObj != undefined) {
        // FormData 对象
        var form = new FormData();
        // 文件对象
        form.append("file", fileObj);
        form.append("fileType", "picture");
        form.append("bucketName", "cmny-oss");
        console.log(form);
        this.$postFormData("opc/file/uploadFile", form).then((res) => {
          if (res.code == 200) {
            this.addForm.picture.push(res.result);
            this.$message({ message: res.message, type: "success" });
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        });
      }
    },

    //删除图片
    handleRemove(file, fileList) {
      console.log(file);
      console.log(this.fileDataList);
      for (let i = 0; i < this.fileDataList.length; i++) {
        if (file.uid == this.fileDataList[i].uid) {
          console.log(i);
          this.fileIndex = i;
          this.fileDataList.splice(i, 1);
        }
      }
      for (let k = 0; k < this.fileList.length; k++) {
        if (fileList.url == this.fileList[k].url) {
          this.fileIndex = k;
          this.addForm.picture.splice(k, 1);
        }
      }
    },

    //图片限制
    uploadSuccess(file) {
      this.fileDataList.push(file);
      const is6 = this.addForm.picture.length >= 6;
      const isJPG = file.type == "image/jpeg" || file.type == "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG或PGN 格式!");
        return false;
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
        return false;
      }
      if (is6) {
        this.$message.error("最多只能上传6张图片");
        return false;
      }
      return isJPG && isLt2M && !is6;
    },

    //新增时家庭住址
    focusAdd() {
      console.log("aaa");
      this.dialogFormVisibleSafe = true;
    },

    //点击地图里面的input搜素框输入搜索，获取所有搜索的地址的数组 []
    markersset(e) {
      console.log(e);
      //输入家庭住址时，让搜索的结果显示
      document.getElementById("bm-local-search").style.display = "block";
    },
    //点击搜索的结果，获取点击获取的地址
    infohtmlset(e) {
      //先置空
      this.addForm.address = "";
      // this.editForm.address=''
      console.log(e);
      console.log(e.address);
      console.log(e.point);
      //把搜索选取的地址赋给外层dialog 家庭地址的input框
      this.addForm.address = e.address;
      // this.editForm.address=e.address;
      //当选取了地址后，让其隐藏
      document.getElementById("bm-local-search").style.display = "none";
    },
    //点击地图dialog叉号关闭 重置
    closeMap() {
      console.log("aaa");
      this.postionMap.lng = "";
      this.postionMap.lat = "";
      this.postionHuiXian.lng = "";
      this.postionHuiXian.lat = "";
      this.show = false;
      this.keyword = ""; //搜索框置空
      //关闭dialog ,input框自动聚焦 比较友好
      // let inputelementAdd=document.getElementById('addressAdd')
      // if(inputelementAdd !=null){//判断一下 因为编辑时打开地图时此值不存在的
      //   inputelementAdd.focus()
      // }
      // let inputelement=document.getElementById('address')
      // if(inputelement !=null){//判断一下 因为新增时打开地图时此值不存在的
      //   inputelement.focus()
      // }
    },
    //点击地图，记住地图选取的地址，清除上次点击的位置
    sureMap() {
      this.dialogFormVisibleSafe = false;
      this.postionMap.lng = "";
      this.postionMap.lat = "";
      this.postionHuiXian.lng = "";
      this.postionHuiXian.lat = "";
      this.show = false;
      this.keyword = ""; //搜索框置空
      //关闭dialog,input框自动聚焦 比较友好
      // let inputelementAdd=document.getElementById('addressAdd')
      // if(inputelementAdd !=null){//判断一下 因为编辑时打开地图时此值不存在的
      //   inputelementAdd.focus()
      // }
      // let inputelement=document.getElementById('address')
      // if(inputelement !=null){//判断一下 因为新增时打开地图此值不存在的
      //   inputelement.focus()
      // }
    },
    //生成地图实例
    handler({ BMap, map }) {
      //(BMap, map)地图组件渲染完毕时触发，返回一个百度地图的核心类和地图实例。百度地图组件是异步加载，
      //请不要尝试在组件的生命周期中访问 BMap 核心类和 map 实例，如有需要，请在所需组件的 ready 事件回调函数的参数中获取。
      console.log(BMap, map);
      //武汉的经纬度 zoom为地图显示的比例
      this.center.lng = 114.31667;
      this.center.lat = 30.51667;
      this.zoom = 15;
      //  //获取定位的数据
      var geolocation = new BMap.Geolocation();
      geolocation.getCurrentPosition(
        (r) => {
          if (r.point) {
            console.log(r.point);
            this.center.lng = r.longitude;
            this.center.lat = r.latitude;
            var point = new BMap.Point(this.center.lng, this.center.lat); //用当前定位的经纬度查找省市区街道等信息
            let geocoder = new BMap.Geocoder(); //创建地址解析器的实例
            console.log(this.center.lng);
            console.log(this.center.lat);
            geocoder.getLocation(r.point, (rs) => {
              console.log(rs.address); //这里打印可以看到里面的详细地址信息，可以根据需求选择想要的
              let markers = new BMap.Marker(r.point);
              console.log(markers);
              // map.addOverlay(markers); //添加
              map.panTo(r.point);
              map.centerAndZoom(r.point, 15);
            });
          }
        },
        { enableHighAccuracy: true }
      );
    },
    //点击获取mark
    getPoint(e) {
      //点击地图获取一些信息，
      console.log(e);
      (this.postionHuiXian.lng = ""), //把会显得点去掉
        (this.postionHuiXian.lat = "");
      this.show = true;
      this.postionMap.lng = e.point.lng; //通过  e.point.lng获取经度
      this.postionMap.lat = e.point.lat; //通过  e.point.lat获取纬度
      this.add.jd = e.point.lng;
      this.add.wd = e.point.lat;
      this.zoom = e.target.getZoom();
      // this.center.lng=e.point.lng;
      // this.center.lat=e.point.lat;
      console.log(e.point);
      let geocoder = new BMap.Geocoder(); //创建地址解析器的实例
      geocoder.getLocation(e.point, (rs) => {
        this.add.site = rs.address;
        this.addForm.address = rs.address;
        // this.editForm.address=rs.address;
        //地址描述(string)=
        console.log(rs.address); //这里打印可以看到里面的详细地址信息，可以根据需求选择想要的
        console.log(rs.addressComponents); //结构化的地址描述(object)
        console.log(rs.addressComponents.province); //省
        console.log(rs.addressComponents.city); //城市
        console.log(rs.addressComponents.district); //区县
        console.log(rs.addressComponents.street); //街道
        console.log(rs.addressComponents.streetNumber); //门牌号
        console.log(rs.surroundingPois); //附近的POI点(array)
        console.log(rs.business); //商圈字段，代表此点所属的商圈(string)
      });
      console.log(e.point); //打印markpoint
    },
    //回显修改的地理
    getLocation() {
      //获取地图信息，
      this.show = true;
      this.postionHuiXian.lng = this.oldmanlng; //获取经度
      this.postionHuiXian.lat = this.oldmanlat; //获取纬度
      this.zoom = 12;
      let center = {};
      center.lng = this.postionHuiXian.lng;
      center.lat = this.postionHuiXian.lat;
      console.log(center);
      let geocoder = new BMap.Geocoder(); //创建地址解析器的实例
      geocoder.getLocation(center, (rs) => {
        console.log(center);
      });
    },
    //点击生成mark点的提示关闭
    infoWindowClose() {
      this.show = false;
    },
    //提示打开
    infoWindowOpen() {
      //这里有个问题纠结了很久，百度的信息窗口默认有个点击其他地方就消失的事件，我没有找到
      //并且信息窗口点击一次显示，一次消失
      //于是我加了一个100毫秒的定时器，保证每次点击地图都可以展示信息窗口
      setInterval(() => {
        this.show = true;
      }, 100);
    },

    //获取二级服务类别
    getServer() {
      console.log();
      let groupId = sessionStorage.getItem("groupId")
      this.$postJson("omc/serviceLevel/select", { groupId }).then(
        (res) => {
          //  this.serverList = res.result.list
          var serverList = [];
          res.result.forEach((item) => {
            if (item.firstLevelId != "230") {
              serverList.push({
                id: item.id,
                name: item.secondLevelName,
              });
            }
          });
          this.serverList = serverList;
        }
      );
    },
    //获取服务范围
    getCommunityList() {
      let params = {
        pageNum: 1,
        pageSize: 999,
      };
      this.$postJson("omc/community/queryListWithPage", params).then((res) => {
        var communityList = [];
        if (res.code == 200) {
          this.communityList = res.result.list;
        } else {
          this.communityList = [];
        }
      });
    },
    //新增上传
    submitForm() {
      console.log(this.addForm, "this.addForm");
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          //处理删除后的图片
          let examinephoto = [];
          for (let i = 0; i < this.addForm.picture.length; i++) {
            if (
              this.addForm.picture[i] !== this.addForm.picture[this.fileIndex]
            ) {
              examinephoto.push(this.addForm.picture[i]);
            }
          }
          console.log(examinephoto, "aaaa");
          let formData = this.addForm;
          let param = {};
          let addUrl = "uac/merchant/add";
          if (formData.principaType == 2) {
            param = {
              serviceId: formData.serviceId, // 服务商id
              serviceStaffId: formData.serviceStaffId, // 员工id
              Address: formData.address, // 商家住址
              principalPhone: formData.principalPhone, // 员工电话
              principalIDCard: formData.principalIDCard, // 员工身份证号
              secondLevelIds: formData.secondLevelIds, // 服务类别
              remake: formData.remark, // 备注
              longitude: formData.longitude, // 地图经度
              latitude: formData.latitude, // 地图纬度
            };
            addUrl = "uac/merchant/tfptServiceSave";
            this.principalNameList.forEach((item) => {
              if (item.id == formData.serviceId) {
                param.merchantName = item.principalName; // 商家店名
              }
            });
          } else {
            param = {
              merchantName: formData.merchantName, // 商家名称
              principalName: formData.principalName, // 负责人姓名
              address: formData.address, // 商家住址
              principalPhone: formData.principalPhone, // 员工电话
              principalIDCard: formData.principalIDCard, // 员工身份证号
              secondLevelIds: formData.secondLevelIds, // 服务类别
              remake: formData.remark, // 备注
              longitude: this.add.jd, // 地图经度
              latitude: this.add.wd, // 地图纬度
              imgsCode: examinephoto.join(";"),
            };
          }
          if (this.status == 0) {
            this.$postJson(addUrl, param).then((res) => {
              if (res.code == 200) {
                this.$message({ message: res.message, type: "success" });
                this.dialogVisible = false;
                this.findPage();
              } else {
                this.$message({ message: res.message, type: "error" });
              }
            });
          } else if (this.status == 2) {
            param.id = this.id;
            this.$postJson("uac/merchant/update", param).then((res) => {
              if (res.code == 200) {
                this.$message({ message: res.message, type: "success" });
                this.dialogVisible = false;
                this.findPage();
              } else {
                this.$message({ message: res.message, type: "error" });
              }
            });
          }
        } else {
          return false;
        }
      });
    },

    //查询分页列表的数据
    findPage(data) {
      let param = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        merchantName: this.filters.merchantName,
        secondLevelId: this.filters.secondLevelId,
      };
      this.$postJson("uac/merchant/select", param).then((res) => {
        if (res.code == 200) {
          // secondLevelIds
          // 处理列表的服务类别
          for (let i = 0; i < res.result.list.length; i++) {
            for (let j = 0; j < res.result.list[i].secondLevelIds.length; j++) {
              if (res.result.list[i].principalName == "") {
                res.result.list[i].principalName =
                  res.result.list[i].merchantName;
              }
              let secondLeve = [];
              for (let k = 0; k < this.serverList.length; k++) {
                if (
                  this.serverList[k].id == res.result.list[i].secondLevelIds[j]
                ) {
                  secondLeve.push(this.serverList[k].name);
                }
              }
              res.result.list[i].secondLeves = secondLeve.join(",");
            }
          }
          this.tableData = res.result.list;
          this.total = Number(res.result.total);
        }
      });
    },

    //翻页
    changePage(val) {
      this.pageNum = val;
      this.currentPage = val;
      this.findPage();
    },

    // 修改table tr行的背景色
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "background-color: #ffffff";
      } else {
        return "background-color: #efefef";
      }
    },
    // 修改table header的背景色
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "color:#2d2d2d;font-weight: 600; text-align: left;font-size: 16px;background-color: #efefef;";
      }
    },
  },
  mounted() {
    this.findPage();
    // 初始化服务项目和服务范围的数据源
    this.getServer();
  },
};
</script>
<style lang="scss" scoped>
.height40 {
  height: 40px;
  line-height: 40px;
}
.oldmanmap {
  margin: 20px 5px;
  border: 1px solid rgb(228, 222, 222);
  .map {
    width: 100%;
    height: 400px;
  }
}
//地图插件·
::deep .BMap_stdMpCtrl {
  top: 50px !important;
}
::deep .citylist_popup_main {
  margin-left: 45px;
}
::deep .el-dialog-map {
  .el-input__inner {
    width: 50%;
  }
}
.fenye {
  margin: 0px;
  padding: 30px 0;
  background: #fff;
}
// ::deep深度作用选择符
::deep .el-dialog__header {
  text-align: left;
  background: rgb(238, 231, 231);
  border-bottom: 2px solid rgb(211, 207, 207);
}
</style>
